document.addEventListener("DOMContentLoaded", function() {
    var mixFoot = document.querySelector(".mix-foot");

    window.addEventListener("scroll", function() {
        if (window.scrollY > 100) {
            mixFoot.classList.add("visible");
        } else {
            mixFoot.classList.remove("visible");
        }
    });
});